/// <amd-module name="SuiteCommerce.SizeChart.Chart.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.SizeChart.Chart.View", ["require", "exports", "Backbone", "suitecommerce_sizechart_chart.tpl"], function (require, exports, Backbone_1, chartTemplate) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ChartView = void 0;
    var ChartView = /** @class */ (function (_super) {
        __extends(ChartView, _super);
        function ChartView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = chartTemplate;
            _this.showSizeChartTitle = options.showSizeChartTitle;
            return _this;
        }
        ChartView.prototype.getContext = function () {
            return {
                chart: this.model.chart,
                description: this.model.description,
                showSizeChartTitle: this.showSizeChartTitle,
                title: this.model.title,
            };
        };
        return ChartView;
    }(Backbone_1.View));
    exports.ChartView = ChartView;
});
